// Choosing between the Bosnian and English halves of API content. The API
// sends both (`name` next to `english_name`); the English half is often empty
// while content is still being translated, so every field falls back to
// Bosnian on its own. Pure, so it runs in Node tests.

// Editor HTML that renders as nothing: tags, non-breaking spaces, whitespace.
function visibleText(html) {
	return String(html)
		.replace(/<[^>]*>/g, "")
		.replace(/&nbsp;|&#160;/gi, " ")
		.trim();
}

export function hasContent(value) {
	if (value === null || value === undefined) return false;
	if (Array.isArray(value)) return value.length > 0;
	if (typeof value !== "string") return true;
	return visibleText(value).length > 0;
}

export function localized(entity, field, language) {
	if (!entity) return undefined;
	if (language === "en") {
		const english = entity[`english_${field}`];
		if (hasContent(english)) return english;
	}
	return entity[field];
}

function isValidQuestion(question) {
	if (!hasContent(question?.question)) return false;

	const answers = question?.answers;
	if (!Array.isArray(answers) || answers.length < 2) return false;
	if (answers.filter((answer) => answer?.isCorrect === true).length !== 1) return false;
	if (!answers.every((answer) => hasContent(answer?.answer))) return false;

	// The option highlight compares answer uuids; missing or repeated ids
	// would light up several options at once.
	const ids = answers.map((answer) => answer?.uuid);
	return ids.every(Boolean) && new Set(ids).size === ids.length;
}

// Answers are graded in the browser from `isCorrect`, so a quiz is either
// entirely English or entirely Bosnian — never a mix of the two sets.
export function pickQuizQuestions(quiz, language) {
	const bosnian = quiz?.questions ?? [];
	if (language !== "en") return bosnian;

	const english = quiz?.english_questions;
	const usable =
		Array.isArray(english) &&
		english.length > 0 &&
		english.length === bosnian.length &&
		english.every(isValidQuestion);

	return usable ? english : bosnian;
}
